{
    "UploadfilesFilename": "File Name",
    "UploadfilesFilesize": "File Size",
    "UploadfilesEmailserroredsendingseebelow": "Click for more information",
    "UploadfilesSuccesswitherrorparagraph": "Your users have been configured. However, there has been an error sending welcome emails.",
    "Resulttableheaderusername": "Username",
    "Resulttableheaderemail": "Email Address",
    "Resulttableheaderrptaccess": "Reporting Access",
    "Resulttableheaderisadmin": "Is Admin?",
    "Resulttableheaderisocagent": "Is OC Agent?",
    "Resulttableheaderenhancemobileapp": "Enhanced Mobile App?",
    "NAME": "LanguageBulkInsertUsers",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Bulk Upload Users",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Import File.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Start",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Processing.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Back",
    "LanguageBulkInsertUsers_UploadfilesButton3": "Confirm",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Import.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Oops.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Confirmation.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Success.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Done",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Hooray! We have successfully configured your users.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Start by downloading and filling out the",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "CSV Template",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "provided.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Confirm that everything has been correctly typed and then proceed to import the completed file here (Any errors with the file will be caught during configuration):",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Choose File",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": " or drag & drop here.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Drop your files here...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "File details:",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Are you sure that you want to close the window and lose the progress?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "Yes",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Cancel",
    "LanguageBulkInsertUsers_ValidationError": "Error: We were unable to process the bulk provisioning request. See below for more information.",
    "LanguageBulkInsertUsers_SuccessTitle": "Please check your changes and confirm.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Error: Invalid file format, please use our CSV template.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Error: Max file size exceeded. Max 10 MB allowed."
}